/**
 * Cart Recommendations Swiper Controller
 */
(function () {
  function initCartRecommendations(context) {
    const root = context || document.querySelector('cart-drawer') || document;
    const swipers = root.querySelectorAll('[data-cart-swiper]');

    if (!swipers.length) return;

    if (typeof Swiper === 'undefined') {
      if (!window._cartSwiperPending) {
        window._cartSwiperPending = true;
        const interval = setInterval(() => {
          if (typeof Swiper !== 'undefined') {
            clearInterval(interval);
            window._cartSwiperPending = false;
            initCartRecommendations(root);
          }
        }, 80);
      }
      return;
    }

    swipers.forEach((swiperEl) => {
      if (swiperEl._cartSwiperInstance) {
        swiperEl._cartSwiperInstance.destroy(true, true);
        swiperEl._cartSwiperInstance = null;
      }

      const prevArrow = swiperEl.closest('.cart-recommendations')?.querySelector('.cart-recommendations__arrow--prev') ||
        swiperEl.querySelector('.cart-recommendations__arrow--prev');
      const nextArrow = swiperEl.closest('.cart-recommendations')?.querySelector('.cart-recommendations__arrow--next') ||
        swiperEl.querySelector('.cart-recommendations__arrow--next');
      const paginationEl = swiperEl.querySelector('.swiper-pagination') ||
        swiperEl.closest('.cart-recommendations')?.querySelector('.swiper-pagination');

      const swiperConfig = {
        slidesPerView: 2,
        spaceBetween: 10,
        grabCursor: true,
        observer: true,
        observeParents: true,
        resizeObserver: true,
        watchOverflow: true,
        navigation: prevArrow && nextArrow ? {
          prevEl: prevArrow,
          nextEl: nextArrow,
        } : false,
        pagination: paginationEl ? {
          el: paginationEl,
          clickable: true,
          dynamicBullets: true,
        } : false,
        breakpoints: {
          0: {
            slidesPerView: 1.8,
            spaceBetween: 8,
          },
          380: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
        },
      };

      try {
        swiperEl._cartSwiperInstance = new Swiper(swiperEl, swiperConfig);
      } catch (err) {
        console.error('Failed to init cart recommendations swiper:', err);
      }
    });
  }

  window.initCartRecommendations = initCartRecommendations;

  // Initialize on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCartRecommendations());
  } else {
    initCartRecommendations();
  }

  // Subscribe to cart updates if pub/sub is present
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      setTimeout(() => initCartRecommendations(), 150);
    });
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target && event.target.querySelector('cart-drawer')) {
      initCartRecommendations(event.target);
    }
  });
})();
